export default function getRGB(color) {
  if (color.match(/^rgb/)) {
    const rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    return {
      r: parseInt(rgb[1], 10),
      g: parseInt(rgb[2], 10),
      b: parseInt(rgb[3], 10),
    };
  }
  const hex = +(`0x${color.slice(1).replace(color.length < 5 && /./g, '$&$&')}`);
  return {
    /* eslint-disable no-bitwise */
    r: hex >> 16,
    g: (hex >> 8) & 255,
    b: hex & 255,
    /* eslint-enable no-bitwise */
  };
}
